import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "database",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2691_53414",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 17,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				y: .5,
				width: 16,
				height: 16,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2691_53414)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "database_2",
				d: "M8 7.83333C9.66667 7.83333 11.0833 7.57222 12.25 7.05C13.4167 6.52778 14 5.9 14 5.16667C14 4.43333 13.4167 3.80556 12.25 3.28333C11.0833 2.76111 9.66667 2.5 8 2.5C6.33333 2.5 4.91667 2.76111 3.75 3.28333C2.58333 3.80556 2 4.43333 2 5.16667C2 5.9 2.58333 6.52778 3.75 7.05C4.91667 7.57222 6.33333 7.83333 8 7.83333ZM8 9.5C8.45556 9.5 9.025 9.45278 9.70833 9.35833C10.3917 9.26389 11.05 9.11111 11.6833 8.9C12.3167 8.68889 12.8611 8.41389 13.3167 8.075C13.7722 7.73611 14 7.32222 14 6.83333V8.5C14 8.98889 13.7722 9.40278 13.3167 9.74167C12.8611 10.0806 12.3167 10.3556 11.6833 10.5667C11.05 10.7778 10.3917 10.9306 9.70833 11.025C9.025 11.1194 8.45556 11.1667 8 11.1667C7.54444 11.1667 6.975 11.1194 6.29167 11.025C5.60833 10.9306 4.95 10.7778 4.31667 10.5667C3.68333 10.3556 3.13889 10.0806 2.68333 9.74167C2.22778 9.40278 2 8.98889 2 8.5V6.83333C2 7.32222 2.22778 7.73611 2.68333 8.075C3.13889 8.41389 3.68333 8.68889 4.31667 8.9C4.95 9.11111 5.60833 9.26389 6.29167 9.35833C6.975 9.45278 7.54444 9.5 8 9.5ZM8 12.8333C8.45556 12.8333 9.025 12.7861 9.70833 12.6917C10.3917 12.5972 11.05 12.4444 11.6833 12.2333C12.3167 12.0222 12.8611 11.7472 13.3167 11.4083C13.7722 11.0694 14 10.6556 14 10.1667V11.8333C14 12.3222 13.7722 12.7361 13.3167 13.075C12.8611 13.4139 12.3167 13.6889 11.6833 13.9C11.05 14.1111 10.3917 14.2639 9.70833 14.3583C9.025 14.4528 8.45556 14.5 8 14.5C7.54444 14.5 6.975 14.4528 6.29167 14.3583C5.60833 14.2639 4.95 14.1111 4.31667 13.9C3.68333 13.6889 3.13889 13.4139 2.68333 13.075C2.22778 12.7361 2 12.3222 2 11.8333V10.1667C2 10.6556 2.22778 11.0694 2.68333 11.4083C3.13889 11.7472 3.68333 12.0222 4.31667 12.2333C4.95 12.4444 5.60833 12.5972 6.29167 12.6917C6.975 12.7861 7.54444 12.8333 8 12.8333Z",
				fill: "#0C98D0"
			})
		})]
	})
});
export default SvgDatabase;
